import React from 'react'
import SignupCard from '../../components/cards/signup-card.jsx'
import css from './signup.scss';

class SignupPage extends React.Component {
    render() {
        return (
            <div className={css.container}>
                <SignupCard />
            </div>
        );
    }

}

export default SignupPage;